import {
  AfterViewInit, ChangeDetectorRef, Component, DoCheck, ElementRef, EventEmitter, Inject, OnDestroy,
  OnInit
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {skip, takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {Subject} from 'rxjs';
import {Api} from "@shared/constants/common-field.constants";

@Component({
    standalone: false,
    selector: 'particle-transmit-form-dialog',
  templateUrl: './transmit-form-dialog.component.html',
  styleUrls: ['./transmit-form-dialog.component.scss']
})
export class TransmitFormDialogComponent implements OnInit, IDialogView, AfterViewInit, OnDestroy {

  data: DialogModel;
  elements: any;
  exportFormHtmlData: string;
  ngUnsubscribe$ = new Subject<void>();
  constructor(private elementRef: ElementRef,
              public changeDetectorRef: ChangeDetectorRef,
              private queryStore: Store<IQueryState>) { }

  ngOnInit() {
    let queryKey =this.getFilingTransmitQueryKey();// this.data.input.targetApi ? 'ScenarioHtmlFormDataByCountryCode' : 'Dac6HtmlFormDataByCountryCode';
    this.queryStore.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, queryKey)).subscribe(item => {
      if (item) {
        this.exportFormHtmlData = item;
        setTimeout(() => {
          this.subscribeToUiClickEvent();
        }, 800);

      }
    });
    QueryProvider.invokeQuery(this.queryStore, queryKey, {'[CODE]': this.data.input.countryCode,
      '[ScenarioType]': this.data.input.scenarioType ? this.data.input.scenarioType : "",
      '[SOURCE_TYPE]': this.data.input.sourceType ? this.data.input.sourceType : ""});
  }
  private getFilingTransmitQueryKey() {
    switch (this.data.input.targetApi){
      case Api.Spreadsheet:
        return 'ScenarioHtmlFormDataByCountryCode';
      case Api.FilingManagerApi:
        let config:any =    {
        "url": "Details/GetTransmitFile?sourceType=[SOURCE_TYPE]&code=[CODE]",
          "api": "SpreadsheetApi",
          "key": "ScenarioHtmlFormDataByCountryCode",
          "invoked": false,
          "Parameters": {
          "[CODE]": "",
            "[ScenarioType]": ""
        },
        "invokeOnce": false,
          "queryType": "GET"
      };

        config.api = Api.FilingManagerApi;
        let k = 'FilingManagerTransmitQueryKey'
        QueryProvider.addConfig(k,config);
        return k;
      default :
        return 'Dac6HtmlFormDataByCountryCode';
    }
  }
  onOkClicked(): boolean {
    return true;
  }
  ngAfterViewInit(): void {
    // this.subscribeToUiClickEvent();
  }

  private subscribeToUiClickEvent() {
    this.changeDetectorRef.detectChanges();
    this.elements = this.elementRef.nativeElement.querySelectorAll('a');
    if (this.elements) {
      this.elements.forEach(element => {
        element.addEventListener('click', () => {
          const elementData = {
            type: element.attributes['data-action-type'].textContent,
            url: element.attributes['data-url'].textContent
          };
          this.data.input['onClick'].emit(elementData);
        });
      });
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
